 if ( matchMedia('screen and (max-width: 768px)').matches ) {
   $('.reviews-main .carousel').flickity({
     wrapAround: true, 
      cellAlign: "center",
      pageDots:false
    });
   
    $('.brand_logo-carousel').flickity({
      wrapAround: true, 
      cellAlign: "center",
      pageDots:false
    });
  }
if ( matchMedia('screen and (min-width: 768px)').matches ) {
    $('.reviews-main .carousel').flickity({
      wrapAround: true, 
      cellAlign: "left",
      pageDots:false
    });
  $('.brand_logo-carousel').flickity({
      wrapAround: true, 
      cellAlign: "left",
      pageDots:false
    });
}



function initScrollZoom() {
  if (!window.gsap || !window.ScrollTrigger) return;

  // Kill previous image triggers only
  ScrollTrigger.getAll().forEach(trigger => {
    if (trigger.vars && trigger.vars.id?.includes("scroll-zoom-image")) {
      trigger.kill();
    }
  });

 
  gsap.utils.toArray(".image-zoom-image").forEach((image) => {
    gsap.fromTo(
      image,
      { scale: 1.3 },
      {
        scale: 1,
        ease: "none",
        scrollTrigger: {
          id: "scroll-zoom-image-default",
          trigger: image,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true
        }
      }
    );
  });


  gsap.utils.toArray(".abasia-custom .banner__media-image").forEach((image) => {
    gsap.fromTo(
      image,
      { scale: 1.3 },
      {
        scale: 1,
        ease: "none",
        scrollTrigger: {
          id: "scroll-zoom-image-default",
          trigger: image,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true
        }
      }
    );
  });



  // SMALL SCALE image → scale 1.1 → 1
  gsap.utils.toArray(".second-custom-banner .scroll-zoom-small").forEach((image) => {
    gsap.fromTo(
      image,
      { scale: 1.20 },
      {
        scale: 1,
        ease: "none",
        scrollTrigger: {
          id: "scroll-zoom-image-small",
          trigger: image,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true
        }
      }
    );
  });


   // SMALL SCALE image → scale 1.1 → 1
  gsap.utils.toArray(".custom-banner .scroll-zoom-small").forEach((image) => {
    gsap.fromTo(
      image,
      { scale: 1.3 },
      {
        scale: 1,
        ease: "none",
        scrollTrigger: {
          id: "scroll-zoom-image-small",
          trigger: image,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true
        }
      }
    );
  });



  ScrollTrigger.refresh();
}

function initScrollTextResize() {
  if (!window.gsap || !window.ScrollTrigger) return;

  // Kill previous text triggers only
  ScrollTrigger.getAll().forEach(trigger => {
    if (trigger.vars && trigger.vars.id?.includes("scroll-text-resize")) trigger.kill();
  });

  const topTexts = document.querySelectorAll(".result-top-text , .result-number p strong");
  if (!topTexts.length) return;

  ScrollTrigger.matchMedia({

    "(min-width: 769px)": function () {
      topTexts.forEach((topText, index) => {
        // Get initial font size from CSS
        const initialSize = parseFloat(getComputedStyle(topText).fontSize);
        let currentSize = initialSize;
        
        // Calculate min/max range based on initial size (±10% range, adjust as needed)
        const minSize = initialSize * 0.95;
        const maxSize = initialSize * 1.14;

        ScrollTrigger.create({
          id: `scroll-text-resize-${index}`,
          trigger: topText,
          start: "top bottom",
          end: "bottom top",
          onUpdate(self) {
            const delta = self.direction === 1 ? 0.666 : -0.666;
            currentSize = gsap.utils.clamp(minSize, maxSize, currentSize + delta);
            gsap.set(topText, { fontSize: currentSize });
          }
        });
      });
    },

    "(max-width: 768px)": function () {
      topTexts.forEach((topText, index) => {
        // Get initial font size from CSS
        const initialSize = parseFloat(getComputedStyle(topText).fontSize);
        let currentSize = initialSize;
        
        // Calculate min/max range based on initial size (±10% range, adjust as needed)
        const minSize = initialSize * 0.95;
        const maxSize = initialSize * 1;

        ScrollTrigger.create({
          id: `scroll-text-resize-mobile-${index}`,
          trigger: topText,
          start: "top bottom",
          end: "bottom top",
          onUpdate(self) {
            const delta = self.direction === 1 ? 0.5 : -0.5;
            currentSize = gsap.utils.clamp(minSize, maxSize, currentSize + delta);
            gsap.set(topText, { fontSize: currentSize });
          }
        });
      });
    }

  });
}
document.addEventListener("DOMContentLoaded", () => {
  initScrollZoom();
  initScrollTextResize();
});

document.addEventListener("shopify:section:load", () => {
  initScrollZoom();
  initScrollTextResize();
});



